<script>
	function screen_lock_action() {
		let wakeLock = null;
		if ("wakeLock" in navigator) {
			navigator.wakeLock.request("screen").then((w) => {
				wakeLock = w;
				console.log("created screen lock");
			});
		}
		return {
			destroy() {
				if (wakeLock) {
					wakeLock
						.release()
						.then(() => console.log("removed screen lock"));
				}
			},
		};
	}
</script>

<div use:screen_lock_action class="screen-lock" />

<style>
	.screen-lock {
		display: none;
	}
</style>
